import { Affix } from 'antd';
import UserImageCircle from '../../../components/UserImageCircle';
import InfoTooltip from "../../../components/InfoTooltip";
import { useProject } from "../../../providers/ClientProjectProvider";
import { useAuth } from "../../../providers/AuthProvider";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import React from "react";

const ProposalFooter = () => {
    const { auth } = useAuth();

    const {
        project,
        isLoading,
        requestSOW,
        cancelSOW,
        isProjectUpdating
    } = useProject();

    const location = useLocation();
    const navigate = useNavigate();

    if (isLoading || location.pathname.includes('profiles')) {
        return null;
    }


    const totalPositions = project.positions?.length;
    const filledPositions = project.positions.filter(posi => posi.hasBeenFilled())
    const canAuthRequestSOW = auth.canRequestSOWForProject(project)

    const renderCTA = () => {
        if (project.isPendingContract()) {
            return (
                <button
                    type="button"
                    id="request-sow-btn"
                    onClick={() => {
                        if (!canAuthRequestSOW) {
                            return TB.showPermissionError();
                        }
                        return navigate(`/client/project/bidding/${project?.id}/contract`);
                    }}
                    className={TB.mapClass("btn btn-primary btn-block w-full", {
                        'disabled-edit-link': !project.hasAssignedCandidates(),
                    })}
                >
                    View SOW
                    {!project.hasRequestedSOW() && !canAuthRequestSOW && (
                        <i className="fa fa-lock ml-1" />
                    )}
                </button>
            )
        }
        if (project.hasRequestedSOW()) {
            return (
                project.isPendingContract() ? (
                    <button
                        type="button"
                        id="request-sow-btn"
                        disabled={isProjectUpdating}
                        onClick={() => {
                            if (!canAuthRequestSOW) {
                                return TB.showPermissionError();
                            }
                            return navigate(`/client/project/bidding/${project?.id}/contract`);
                        }}
                        className={TB.mapClass("btn btn-primary btn-block w-full", {
                            'disabled-edit-link': !project.canRequestSOW(),
                        })}
                    >
                        View SOW
                        {!project.hasRequestedSOW() && !canAuthRequestSOW && (
                            <i className="fa fa-lock ml-1"/>
                        )}
                    </button>
                ) : (
                    <button
                        type="button"
                        disabled={isProjectUpdating || isProjectUpdating}
                        onClick={() => {
                            if (!canAuthRequestSOW) {
                                return TB.showPermissionError();
                            }
                            return cancelSOW();
                        }}
                        className={TB.mapClass("btn btn-primary btn-block w-full", {
                            'disabled-edit-link': !canAuthRequestSOW
                        })}
                    >
                        Cancel SOW Request
                        {!canAuthRequestSOW && (
                            <i className="fa fa-lock ml-1"/>
                        )}
                    </button>
                )
            )
        }

        return (
            <React.Fragment>
                <button
                    type="button"
                    id="request-sow-btn"
                    onClick={() => {
                        if (!canAuthRequestSOW) {
                            return TB.showPermissionError();
                        }
                        return requestSOW();
                    }}
                    className={TB.mapClass("btn btn-primary btn-block w-full", {
                        'disabled-edit-link': !project.canRequestSOW() || !!project.contract_requested_at,
                    })}
                    disabled={isProjectUpdating}>
                    Request SOW
                    {!project.hasRequestedSOW() && !canAuthRequestSOW && (
                        <i className="fa fa-lock ml-1" />
                    )}
                </button>

                {project.isBYO() && !project.hasFilledAllPositions() && (
                    <InfoTooltip type="gray" placement="bottom" target="request-sow-btn">
                        <p className="p-0 text-white">All positions must be filled to request SoW</p>
                    </InfoTooltip>
                )}
                {project.isService() && !project.assigned_team_candidate && (
                    <InfoTooltip type="gray" placement="bottom" target="request-sow-btn">
                        <p className="p-0 text-white">A team proposal must be selected to request SoW</p>
                    </InfoTooltip>
                )}
            </React.Fragment>
        )
    }

    return (
        <Affix offsetBottom={-1} style={{ zIndex: 25 }}>
            <div className="bidding-footer-nav bidding-footer-alt drop-shadow-xl">
                <div className="w-full flex justify-end max-w-[1225px]">

                    <div className="flex items-center gap-x-8 md:gap-x-16">
                        <div>
                            {project.hasRequestedSOW() ? (
                                <p className="text-bold">
                                    <i className="fas fa-check mr-1 text-success" />
                                    {`SoW ${project.isAwaitingContract() ? 'requested' : 'ready'} for ${project.isService() ? 'Team' : `${filledPositions.length} positions`}`}
                                </p>
                            ) : (
                                <p className="text-bold">{!project.isService() ? `${filledPositions.length} of ${totalPositions} positions filled` : `${project.shortlisted_candidates_count} proposals requested.`}</p>
                            )}
                        </div>

                        {project.positions?.length > 0 && (
                            <div className="hidden md:flex flex-row items-center gap-2">
                                {project.positions.map((position, index) => {

                                    let hasBeenFilled = position.hasBeenFilled();
                                    let talent = {};

                                    if (hasBeenFilled && position.assigned_candidate) {
                                        talent = position.assignedCandidate()
                                    }

                                    let assigned = (hasBeenFilled && talent?.image_path);
                                    // let active = parseInt(positionId) === position.id;
                                    let key = `pos${position.id}-talent${talent?.id || 'unassigned'}`;

                                    let targetPath = position.currentBriefStep();
                                    let canNavigate = !location.pathname.includes(targetPath);

                                    return (
                                        <div key={key}
                                             className={TB.mapClass("position-swiper-slide", {
                                                 assigned,
                                                 unassigned: !assigned,
                                                 //  active
                                             })}
                                        >
                                            <div
                                                id={key}
                                                className={TB.mapClass("role-img", {
                                                    clickable: canNavigate
                                                })}
                                                onClick={(e) => {
                                                    if (canNavigate) {
                                                        navigate({
                                                            pathname: `/client/project/bidding/${project?.id}${targetPath}`,
                                                            search: '?from=brief'
                                                        })
                                                    }

                                                }}
                                            >
                                                {(hasBeenFilled && talent?.image_path) ? (
                                                    <UserImageCircle
                                                        user={talent}
                                                        hideTooltip={true}
                                                        size={50} className="img-fluid img-grayscale" />
                                                ) : (
                                                    <span>
                                                        <i className="fa fa-user-circle" />
                                                        <span className="position-index">
                                                            {index + 1}
                                                        </span>
                                                    </span>
                                                )}
                                            </div>

                                            <InfoTooltip type="dark" placement="bottom" target={key}>
                                                <div className="position-tooltip">
                                                    <p>{position.title}</p>
                                                    <p>
                                                        {hasBeenFilled ? talent.displayName?.(auth) : "TBD"}
                                                    </p>
                                                </div>
                                            </InfoTooltip>
                                        </div>
                                    )
                                })}
                            </div>
                        )}

                        <div>
                            {renderCTA()}
                        </div>
                    </div>
                </div>
            </div>


        </Affix>
    )
}

export default ProposalFooter;